import { render, staticRenderFns } from "./QuestionText.vue?vue&type=template&id=bc962a7e&scoped=true&"
import script from "./QuestionText.vue?vue&type=script&lang=js&"
export * from "./QuestionText.vue?vue&type=script&lang=js&"
import style0 from "./QuestionText.vue?vue&type=style&index=0&id=bc962a7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc962a7e",
  null
  
)

export default component.exports